import React from 'react';
import { styled } from '@uhg-abyss/web/tools/styled';
import { Button } from '@uhg-abyss/web/ui/Button';
import { useAccounts } from '@/context/AccountContext';
import { useTranslation } from 'react-i18next';

interface SwitchAccountButtonProps {
    hideIcon?: boolean;
    className?: string;
    id?: string;
}

const StyledButton = styled(Button, {
    padding: 0,
    minHeight: 'unset',
    cursor: 'pointer',
    fontSize: '0.9rem',
    gap: 0,
    verticalAlign: 'baseline',

    '&:hover': {
        borderColor: '$info1'
    },
});

const SwitchAccountButton: React.FC<SwitchAccountButtonProps> = ({ hideIcon, className, id }) => {
    const {
        setIsAccountSwitcherOpen,
    } = useAccounts();
    const { t } = useTranslation();

  return (
    <StyledButton
        id={id ?? "switchAccountBtn"}
        className={className}
        variant="text"
        icon={hideIcon ? undefined : { icon: 'unfold_more', position: 'trailing' }}
        onClick={() => setIsAccountSwitcherOpen(true)}
    >
        {t('switchAccount')}
    </StyledButton>
  );
};

export default SwitchAccountButton;
